import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ListPanelWrapper } from '@eika/link-panel';

import { AccountListSkeleton } from '..';
import { Account } from '../../../../generated-types';

type AccountsOverviewContentProps = {
    accounts: Account[] | undefined;
};

export const AccountsOverviewLoader = ({ accounts }: AccountsOverviewContentProps) => (
    <ListPanelWrapper
        className="account-overview loading"
        data-testid="loader"
        titleContent={<Skeleton className="account-list__skeleton-header" width={150} height={30} />}
        contentWrapperAs="ol"
    >
        <AccountListSkeleton count={accounts?.length} noTitle />
    </ListPanelWrapper>
);
